const SEVERITY_MAP = {
    Info: 'neutral-100',
    Error: 'status-warning-100',
    Critical: 'status-danger-100',
    Warning: 'status-alert-100',
    Debug: 'neutral-100',
}

const STATUS_MAP = {
    green: 'status-success-100',
    red: 'status-danger-100',
    yellow: 'status-alert-100',
    orange: 'status-warning-100',
    gray: 'neutral-100',
    secondary: 'secondary-100',
}

const ACTIVE_MAP = {
    Active: 'secondary',
    Cleared: 'success',
    Ignored: 'light',
}

const ZENOSS_EVENT_MAP = {
    5: 'danger',
    4: 'warning',
    3: 'busy',
}

const EVENT_STATE_MAP = {
    Active: 'success',
    Cleared: 'default',
    Ignored: 'warning',
}

const TICKET_STATE_MAP = {
    CL: ' Closed',
    ESC: ' Escalate',
    FLD: ' Field Update',
    INIT: ' Creation',
    RO: ' Re-Open',
    ST: ' Status Update',
    TR: ' Transfer',
    LOG: ' Log Comment',
    SOLN: ' Log Solution',
    CB: ' Callback',
    NF: ' Manual Notify',
    ATTACHDOC: ' Attachment',
    PS: ' Pending Supplier',
    WFF: ' Waiting for Feedback',
    RE: ' Resolved',
    ASS: ' Assigned',
    WIP: ' Work in Progress',
    OP: ' Open',
    SCH: ' Scheduled',
    PNDCHG: ' Pending Change Order',
    PR: ' Pending Release',
    PP: ' Pending Problem',
}

function getVariantOnDevices(entity) {
    if (entity?.red_devices) {
        return STATUS_MAP['red']
    }
    if (entity?.orange_devices) {
        return STATUS_MAP['orange']
    }

    if (entity?.yellow_devices) {
        return STATUS_MAP['yellow']
    }
    return STATUS_MAP['green']
}

const COMPUTED_OS_MAP = {
    AIX: 'aix',
    Appliance: 'appliance',
    ApplicanceOS: 'linux',
    CentOS: 'linux',
    'Citrix Hypervisor 8.2 Standard (Citrix)': 'citrix-xen-server',
    'Citrix Hypervisor 8.2 Standard (Citrix) x64': 'citrix-xen-server',
    'Citrix NetScaler 11 (Citrix)': 'citrix-xen-server',
    'Citrix NetScaler 12 (Citrix)': 'citrix-xen-server',
    'Citrix NetScaler 13 (Citrix)': 'citrix-xen-server',
    'Citrix NetScaler 13 (Citrix) x64': 'citrix-xen-server',
    Debian: 'ubuntu',
    'Fedora CoreOS': 'ubuntu',
    FortiOS: 'ci',
    FreeBSD: 'ci',
    GCOS: 'ci',
    'HP-UX 11i (HP-UX)': 'hp-ux',
    'HP-UX 11i v3': 'hp-ux',
    'HW without OS': 'ci',
    'IBM PowerVM VIOS': 'ibm',
    Linux: 'linux',
    'Not specified': 'ci',
    'Oracle VM Server': 'oracle',
    'Photon OS (VMware)': 'vmware',
    'Photon OS 3 (VMware)': 'vmware',
    'Red Hat': 'linux',
    'SUSE Linux': 'linux',
    'VMware ESXi': 'vmware',
    'VMware vCenter Server 5.5 (VMware)': 'vmware',
    'VMware vCenter Server 6.7 (VMware)': 'vmware',
    'VMware vCenter Server 7.0 (VMware)': 'vmware',
    'VMware vCenter Server 7.0 (VMware) x64': 'vmware',
    Windows: 'windows',
    'Windows Server': 'windows',
    XenServer: 'citrix-xen-server',
    default: 'ci',
}

const variantMappersObject = {
    SEVERITY_MAP,
    STATUS_MAP,
    ACTIVE_MAP,
    ZENOSS_EVENT_MAP,
    getVariantOnDevices,
    COMPUTED_OS_MAP,
    EVENT_STATE_MAP,
    TICKET_STATE_MAP,
}

export default variantMappersObject
